export const PLANS_FEATURE_KEYS = 'plans';
